import  { useEffect } from "react";
import { connect } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { getAccessToken, getProfilePresence } from "../../../Services/GraphServices";
import { setMyAgentProfilePresences } from "../../../Redux/Actions/myAgentProfileActions";

const PresenceProfileContainer = ( {setMyAgentProfilePresences} ) => {
  const authContext = useMsal();
  const { accounts, instance } = authContext;
  const activeAccount = accounts[0];
 
  // Fonction pour récupérer et mettre à jour les présences
  const fetchProfilePresence = () => {
    getAccessToken(instance, activeAccount)
      .then((token) => {
        getProfilePresence(token)
          .then((presenceData) => {
            setMyAgentProfilePresences(presenceData);
          })
          .catch((error) => {
            console.error("Erreur lors de la récupération  de la présence du profil:", error);
          });
      })
      .catch((error) => {
        console.error("Erreur lors de l'obtention du jeton d'accès:", error);
      });
  };

  useEffect(() => {
        fetchProfilePresence();

      const interval = setInterval(() => {
        fetchProfilePresence();
      }, 5000);

      return () => clearInterval(interval);
    
  }, []);

 
};



const mapDispatchToProps = (dispatch) => ({
    setMyAgentProfilePresences: (presencesProfile) => dispatch(setMyAgentProfilePresences(presencesProfile)), 
});

export default connect(null, mapDispatchToProps)(PresenceProfileContainer);
